<template>
  <div class="step__block-field top">
    <h3>TOTAL DUE</h3>

    <PriceValue
      :price="estimateReviewStore.totalDue"
      class="step__block-field-price"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";

import { Pricing } from "@/app/domain";
import { PriceValue } from "@/shared";

import { PricingService } from "@/app/services/pricing.service";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useEstimateReviewStore } from "@/stores/new/estimateReview.store";

const estimateStore = useNewEstimateStore();
const estimateReviewStore = useEstimateReviewStore();
const dealType = computed(() => estimateStore.estimate.dealTypeCode);

const pricingService = new PricingService();
watch(
  () => [estimateReviewStore.subtotalPrice, estimateStore.estimate.taxSum],
  () => {
    const totalDue = pricingService.calculateTotalDuePrice();
    const formattedTotalDue = new Pricing(
      totalDue.price,
      totalDue.priceB2C,
      totalDue.priceB2B,
    );

    estimateReviewStore.totalDue = formattedTotalDue;
  },
  { deep: true, immediate: true },
);

watch(
  () => estimateReviewStore.totalDue,
  () => {
    const totalWithTax = estimateReviewStore.totalDue
      .getSystemPrice(dealType.value)
      .getValue();
    estimateStore.estimate.totalWithTax = totalWithTax;
  },
  { deep: true, immediate: true },
);
</script>

<style lang="scss" scoped>
.step__block-field {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-top: 32px;
  margin-top: 32px;
  border-top: 1px solid #d2d8e3;
}

.step__block-field h3 {
  color: #404d63;
  font-family: Gilroy;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}

.step__block-field-price {
  color: #404d63;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
}
</style>
